import {AppUrls} from 'shared/config/model/urls';
import {Pages} from 'shared/config/model/pages';

import React from 'react';
import {i18n} from '@lingui/core';
import {t} from '@lingui/core/macro';

import Delete from 'shared/ui/icons/General/Delete';
import Download from 'shared/ui/icons/General/Download';
import {ExceededModal} from 'entities/user';
import {MonitorsScreen} from 'entities/monitor';
import useDomainMonitors from 'features/domain/model/useDomainMonitors';
import {getDomainBatchModalHeader} from 'features/domain/lib/domainBatchHelper';
import {isTranslate} from 'shared/lib/lang';

import CreateDomainMonitorButton from '../CreateDomainMonitorButton/CreateDomainMonitorButton';
import DomainMonitorRow from '../DomainMonitorRow/DomainMonitorRow';
import DomainMonitorFiltersFormHandler from '../DomainMonitorsFilters/DomainMonitorFiltersFormHandler';
import DomainMonitorsExportModal from '../DomainMonitorsExport/DomainMonitorsExportModal';
import DomainMonitorBatchOperationsForm from '../DomainMonitorForm/DomainMonitorBatchOperationsForm';
import DomainMonitorModal from '../DomainMonitorModal';

const DomainMonitors: React.FC = () => {
    const {
        user,
        sort,
        pagination,
        isLoading,
        isFetching,
        refetch,
        activeCount,
        maxDomainMonitors,
        list,
        handleCreate,
        isCreateOpen,
        isExceededOpen,
        closeCreate,
    } = useDomainMonitors();

    return (
        <MonitorsScreen
            documentTitle={t`Мониторинг доменов | Overseer`}
            title={i18n._(Pages.DOMAIN_MONITORS)}
            count={activeCount ?? 0}
            maxCount={maxDomainMonitors}
            backUrl={AppUrls.HOME}
            isFetching={isFetching}
            refetch={refetch}
            searchField="domain"
            FiltersFormHandler={DomainMonitorFiltersFormHandler}
            renderExportModal={(state) => <DomainMonitorsExportModal {...state}/>}
            list={list}
            extraMassActions={[
                {
                    value: 'export',
                    label: t`экспорт`,
                    icon: <Download/>,
                    title: t`Экспортировать`,
                },
                {
                    value: 'remove-by-url',
                    label: t`удаление по списку`,
                    icon: <Delete/>,
                    title: t`Удалить по списку`,
                    ignoreSelection: true,
                },
            ]}
            getBatchHeader={getDomainBatchModalHeader}
            renderBatchForm={(props) => <DomainMonitorBatchOperationsForm {...props}/>}
            createButton={<CreateDomainMonitorButton onClick={handleCreate} disabled={list.hasSelectedItems}/>}
            createText={t`Добавить домен`}
            onCreate={handleCreate}
            columns={[
                {label: t`Домен`, sort: 'domain'},
                {label: t`SSL действителен до`, sort: 'ssl_active_to'},
                {label: t`Домен оплачен до`, sort: 'domain_active_to'},
                {label: t`Редирект HTTPS`, sort: 'ssl_redirect'},
                ...(!isTranslate() ? [{label: t`Блокировка РКН`, sort: 'rkn_block'}] : []),
                {label: t`Статус`, sort: 'active'},
                {label: ''},
            ]}
            items={pagination?.items}
            rowFactory={(item) =>
                <DomainMonitorRow
                    key={item.uuid}
                    item={item}
                    user={user}
                    hasSelectedItems={list.hasSelectedItems}
                />
            }
            isLoading={isLoading}
            pagination={pagination}
            sort={sort}
        >
            <DomainMonitorModal
                open={isCreateOpen}
                handleClose={closeCreate}
            />
            <ExceededModal
                isOpen={isExceededOpen}
                handleClose={closeCreate}
                type="domain_monitors"
            />
        </MonitorsScreen>
    );
};

export default DomainMonitors;
